<form [formGroup]="deleteAccountForm" (ngSubmit)="onSubmitDeleteAccountForm()" class="wrapper-account-page">
  <span class="title-settings-page">
    {{'ACCOUNT.delete_account' | translate}}
  </span>
  <span class="subtitle-settings-page" style="color: #ffffff;"><b>
    {{'ACCOUNT.are_you_sure_you_want_to_delete_your_account?' | translate}}
  </b></span>
  <span class="subtitle-settings-page">
    {{'ACCOUNT.when_you_delete_it_you_will_not_be_able_to_restore_it' | translate}}
  </span>
  <div class="wrapper-input" [ngClass]="{'error': deleteAccountForm.controls['password'] | formControlErrorMessages: 'Wrong password, try again.': formTriedToSubmit}">
    <span class="label-input">
      {{'ACCOUNT.password' | translate}}
    </span>
    <div class="custom-input">
      <input
        [type]="isPasswordVisible ? 'text' : 'password'"
        [placeholder]="'ACCOUNT.enter_password' | translate"
        formControlName="password">
      <img *ngIf="!isPasswordVisible" (click)="isPasswordVisible = true" class="icon-input" src="../assets/icons/outline/icon-outline-eye.svg" alt="">
      <img *ngIf="isPasswordVisible" (click)="isPasswordVisible = false" class="icon-input" src="../assets/icons/outline/icon-outline-eye-with-slash.svg" alt="">
    </div>
    <div *ngIf="deleteAccountForm.controls['password'] | formControlErrorMessages: null: formTriedToSubmit" class="wrapper-error-message">
      <img src="../assets/icons/outline/icon-outline-attention.svg" alt="">
      <span>{{deleteAccountForm.controls['password'] | formControlErrorMessages: null: formTriedToSubmit}}</span>
    </div>
  </div>
  <!--       Button submit       -->
  <div class="wrapper-submit-settings">
    <button type="submit" class="custom-btn custom-btn--primary">
      <span>{{'ACCOUNT.delete_account' | translate}}</span>
    </button>
  </div>
</form>
